import store from '@/store'

class Socket {
  constructor (host, store) {
    this.startTime = (new Date()).getTime()
    const self = this
    this.restartDelay = 5
    this.host = host
    this.store = store
    this.connect()
    this.waiting = []
    this.counter = 0
    this.session = '82154955cfb6a2932d28c98bf9610885'

    setInterval(function () {
      if (self.socket && self.socket.readyState === 3) {
        self.store.commit('Server/reconnect', self.restartDelay)
        if (self.restartDelay <= 0) {
          self.restartDelay = 5
          self.connect()
        } else {
          self.restartDelay--
        }
      }
    }, 1000)
  }

  connect () {
    const self = this
    this.socket = new WebSocket(this.host)
    this.store.commit('Server/name', this.socket.url)
    this.store.commit('Server/status', this.socket.readyState)

    this.socket.onopen = function () {
      self.store.commit('Server/status', this.readyState)
      self.send({ type: 'connect', value: self.getSession() })

      if (self.store.iDebug === true) {
        console.log(((new Date()).getTime() - self.startTime) + 'ms', 'socket connected: ')
      }

      self.page()

      while (self.waiting.length > 0) {
        const message = self.waiting.shift()
        self.send(message)
      }
    }
    this.socket.onopen.bind(this)

    this.socket.onclose = function () {
      const started = self.store.getters['Server/dateStartConnexion']
      self.store.commit('Server/close', this.readyState)

      if (self.store.iDebug === true) {
        console.log(((new Date()).getTime() - self.startTime) + 'ms', 'socket closed: ' + ((new Date()).getTime() - started) + 'ms')
      }
    }
    this.socket.onclose.bind(this)

    this.socket.onerror = function () {
      self.store.commit('Server/status', this.readyState)
    }
    this.socket.onerror.bind(this)

    this.socket.onmessage = function (event) {
      if (event.data) {
        const data = JSON.parse(event.data)
        // Une réponse sans données (résultat vide, ou erreur backend) doit tout de
        // même atteindre sa mutation : c'est elle qui retombe les drapeaux de
        // chargement. La rejeter ici laissait par exemple Sport/Game/loading à true
        // indéfiniment, donc le spinner de l'entête tournait sans fin.
        // On normalise null/undefined en tableau vide pour que les mutations qui
        // font .sort()/.map()/.forEach() sur la charge utile ne cassent pas.
        if (data.callback && data.callback !== 'user.auth') {
          if (data.data == null) {
            data.data = []
          }
          if (self.store.iDebug === true) {
            console.log(((new Date()).getTime() - self.startTime) + 'ms', self.counter++, 'received', data)
          }
          self.store.commit(data.callback, data.data)
        }
      }
    }
    this.socket.onmessage.bind(this)
  }

  page () {
    const page = this.store.getters['Server/page']
    if (page !== null) {
      this.send({ type: 'page', value: page })
    }
  }

  get (module, callback, parameters) {
    this.send({ type: 'get', module, callback, parameters })
  }

  post (module, callback, parameters, callParameters) {
    this.send({ type: 'post', module, callback, parameters, callParameters })
  }

  put (module, callback, parameters, callParameters) {
    this.send({ type: 'put', module, callback, parameters, callParameters })
  }

  delete (module, callback, parameters, callParameters) {
    this.send({ type: 'delete', module, callback, parameters, callParameters })
  }

  provider (provider, method, callback, parameters, callParameters) {
    this.send({ type: 'provider', provider: provider, method: method, callback, parameters, callParameters })
  }

  send (message) {
    if (this.store.iDebug === true) {
      console.log(((new Date()).getTime() - this.startTime) + 'ms', this.counter++, 'request', message, (this.socket.readyState !== 1 ? 'waiting' : 'direct'))
    }
    if (this.socket.readyState !== 1) {
      this.waiting.push(message)
    } else {
      this.socket.send(JSON.stringify(message))
    }
  }

  getSession () {
    let session = this.session
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const [key, value] = cookies[i].split('=')
      if (key.trim() === 'PHPSESSID') {
        session = value.trim()
      }
    }
    return session
  }
}

const socket = new Socket(process.env.VUE_APP_WS_URL, store)

export default socket
